import { domReady } from 'utils/dom-ready'
import { trackEvent } from '@/analytics/track'

export function sendQueuedTrackingEvents() {
  const dataElement = document.getElementById('queued-tracking-events')
  if (dataElement) {
    const queuedEvents = JSON.parse(dataElement.dataset.events)

    for (let queuedEvent of queuedEvents) {
      trackEvent(
        queuedEvent.name,
        queuedEvent.parameters,
        queuedEvent.identity
      )
    }
  }
}

domReady(sendQueuedTrackingEvents)
